import React from 'react';
import './spinner.css'

export const Spinner = () => {
    return (
        <div className='spinner-block'>
            <div className="lds-dual-ring" />
        </div>
    );
};